import { render, staticRenderFns } from "./Vipadd.vue?vue&type=template&id=0021ba34&"
import script from "./Vipadd.vue?vue&type=script&lang=js&"
export * from "./Vipadd.vue?vue&type=script&lang=js&"
import style0 from "./Vipadd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports